import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash-es';

@Component({
  selector: 'pps-grid-checkbox',
  template: `
    <input type="checkbox" (click)="checkedHandler($event)" [checked]="checked" />
  `,
  styles: [
  ],
})
export class GridCheckboxComponent implements AgRendererComponent {
  params: any;
  checked: boolean;
  checkValue: string;
  constructor() { }

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    
    if (this.params.column.colId === this.params["checkboxValueColId"]){
      this.checked = this.params.data[this.params["checkboxValueColId"]];
    }
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  checkedHandler(event) {
    let checked = event.target.checked;
    if (this.params.column.colId === this.params["checkboxValueColId"]){
      this.params.data[this.params["checkboxValueColId"]] = checked;
    }

    if (this.params.context.componentParent.updateData){
      this.params.context.componentParent.updateData(this.params.data);
    }
  }  
}